import { getData, queryString } from '@/util/Axios'

export const ApiParams = (axios, obuBaseUrl) => {
  axios.setBaseURL(obuBaseUrl)

  const loadParams = async (types) => {
    if (Array.isArray(types)) {
      types = types.join(',')
    }

    const params = { types }

    const result = await axios.get('/api/params?' + queryString.stringify(params))
    return result.data
  }

  const loadSignature = async () => {
    const result = await axios.get('/api/settings/user/signature')
    return result.data
  }

  const saveSignature = async (signature) => {
    const result = await axios.post('/api/settings/user/signature', { signature })
    return result.data
  }

  const checkVies = async (payload) => {
    const result = await axios.post('/api/vies', { payload })
    return result.data
  }

  const updateUserProfile = async (payload) => {
    const result = await axios.post('/api/profile', { payload })
    return result.data
  }

  const changePassword = async (payload) => {
    const result = await axios.post('/api/change-password', { payload })
    return result.data
  }

  const obuBridgeSignIn = async () => {
    const result = await axios.get('/auth/bridge')
    return result.data
  }

  const globalSearch = async (payload) => {
    const result = await axios.get('/api/global-search', { payload })
    return result.data
  }

  const obuBridgeLegacyRedirect = async () => {
    // VITE_APP_LEGACY_CLIENT
    const result = await axios.get('/auth/bridge/redirect')
    return result.data
  }

  const loadNotifications = async () => {
    const result = await axios.get('/api/notifications')
    return result.data
  }

  const notificationSetRead = async (id) => {
    const result = await axios.get(`/api/notifications/read/${id}`)
    return result.data
  }

  const notificationSetReadAll = async (id) => {
    const result = await axios.get('/api/notifications/read/all')
    return result.data
  }

  return {
    obuBridgeSignIn,
    obuBridgeLegacyRedirect,
    loadNotifications,
    notificationSetRead,
    notificationSetReadAll,
    loadParams,
    changePassword,
    loadSignature,
    saveSignature,
    updateUserProfile,
    checkVies
  }
}
